<!-- 推荐仓库 -->
<template>
<div class="info-block">
  <a   class="info-block-a">
    <div class="div-1" v-bind:style="{backgroundImage:'url('+info.cover_img+')'}">
      <div class="div-1-1">{{info.name}}</div>
      <div class="div-1-2">{{info.area.substring(0,20)}}</div>
      <div class="div-1-3">
          <table class="div-1-4-table" cellpadding="0" cellspacing="0" border="0px">
            <tr>
              <td class="td-title">可租面积</td>
              <td class="td-title">起租面积</td>
            </tr>
            <tr>
              <td class="td-value">{{info.able_area}}</td>
              <td class="td-value">{{info.start_area}}</td>
            </tr>
          </table>
      </div>
      <div class="div-1-4">
          <table class="div-1-4-table" cellpadding="0" cellspacing="0" border="0px">
            <tr>
              <td class="td-value price">￥{{info.price}}</td>
              <td class="td-title" rowspan="2">
                <router-link :to="'/cyfw/ccwL/ckDetail/'+info.id" class="td-action-1" target="_blank">
                我要看仓
                </router-link>
              </td>
            </tr>
            <tr>
              <td class="td-title">价格（元/m²每月）</td>
            </tr>
          </table>
      </div>
    </div>
  </a>
</div>
</template>
<script>
export default {
  name: 'CyfwInfo6',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;

  height:308px;
  padding:0px 0px 0px 0px;
  margin:0px 0px 10px 0px;
  //background-color:red;
  border:0px solid #ddd;
  //box-shadow: #bbb 0px 0px 10px;

}

.info-block .info-block-a:hover > .div-1{
  //border:1px solid var(--color6);
  //box-shadow:0px 0px 1px 0px var(--color6);
}

.div-1{
  position:relative;
  box-sizing:border-box;
  height:308px;
  width:100%;
  padding:140px 0px 0px 0px;
  margin:0 auto;
  //background:var(--color6);
  color:#fff;
  border:1px solid #ddd;
  background-size: 100% 140px;
  background-repeat: no-repeat;
  background-position: 0 0;
}

.div-1-1{
  height:30px;
  padding:8px;
  font-size:14px;
  font-weight:600;
  text-align:left;
  line-height:20px;
  color:#000;
}

.div-1-2{
  height:30px;
  padding:8px;
  font-size:12px;
  color:#888888;
  text-align:left;
  line-height:20px;
  color:#888;
  //background:yellow;
}

.div-1-3{
  height:50px;
  padding:8px;
  font-size:12px;
  color:#888888;
  text-align:left;
  line-height:15px;
}

.div-1-3 table{
  width:100%;
}

.div-1-3 table .td-title{
  text-align:left;
  height:20px;
  line-height:20px;
  color:#888;
}

.div-1-3 table .td-value{
  text-align:left;
  height:20px;
  font-size:14px;
  line-height:20px;
  color:var(--color2);
}

.div-1-4{
  height:50px;
  padding:8px;
  font-size:12px;
  color:#888888;
  text-align:left;
  line-height:15px;
}

.div-1-4 table{
  width:100%;
}

.div-1-4 table .td-title{
  text-align:left;
  height:20px;
  line-height:20px;
  color:#888;
}

.div-1-4 table .td-value{
  text-align:left;
  height:20px;
  //font-size:14px;
  //line-height:20px;
  //color:var(--color2);
}

.div-1-4-table .price{
  font-size:18px;
  font-weight:600;
  color:var(--color6);
}

.div-1-4-table .td-action-1{
  display:block;
  height:30px;
  width:100px;
  padding:5px 10px 5px 10px;
  border:1px solid var(--color7);
  color:#888;
  line-height:20px;
  text-align:center;
  //background:yellow;
}

.div-1-4 .td-action-1:hover{
  color:#fff;
  background:var(--color7);
  border:1px solid var(--color7);
}
</style>



// WEBPACK FOOTER //
// src/components/module/CyfwInfo6.vue